import Biochemistry from './Biochemistry';

export default Biochemistry;
